import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import useApiCall from '../../../../hooks/useApiCall';
import { HandleOpenChangeStatusModalI, WorkplaceChangingStatusType } from '../../types';
import WorkplacesService from '../../../../services/WorkplacesService';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';

interface UseUpdateWorkplaceStatusInterface {
  loadWorkplaces: () => Promise<void>;
  resetFields: () => void;
}

interface UpdateWorkplaceStatusInterface {
  id: number;
  active: boolean;
}

export default function useUpdateWorkplaceStatus({
  loadWorkplaces,
  resetFields,
}: UseUpdateWorkplaceStatusInterface) {
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [changeStatusModalShow, setChangeStatusModalShow] = useState(false);
  const [workplaceChanginStatus, setWorkplaceChangingStatus] = useState({} as WorkplaceChangingStatusType);

  const { apiCall } = useApiCall();
  const { userCode, userProfile, companyCode } = useGetGeneralAppData();

  const updateWorkplaceStatus = useCallback(async ({ id, active }: UpdateWorkplaceStatusInterface) => {
    await apiCall({
      apiToCall: WorkplacesService.updateWorkplaceStatus,
      onStartLoad: () => setIsUpdatingStatus(true),
      onEndLoad: () => {
        setChangeStatusModalShow(false);
        setIsUpdatingStatus(false);
      },
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        codEmpresa: companyCode,
        dadosEndereco: [{
          tipoEnd: 4,
          codEnd: id,
          endAtivo: active,
        }]
      }),
      actionAfterResponse: (apiResponse) => {
        if (!apiResponse.codigo) {
          toast.error(`Não foi possível alterar o status do local. Por favor, tente novamente (${apiResponse.msg})`);
          return;
        }
        toast.success(`O local foi ${active ? 'reativado' : 'inativado'} com sucesso`,);
        setChangeStatusModalShow(false);
        loadWorkplaces();
        resetFields();
      },
      catchMessage: 'Não foi possível alterar o status do local. Por favor, tente novamente',
    });
  }, [apiCall, companyCode, loadWorkplaces, resetFields, userCode, userProfile]);

  function handleOpenChangeStatusModal({ name, id, active }: HandleOpenChangeStatusModalI) {
    setChangeStatusModalShow(true);
    setWorkplaceChangingStatus({
      name,
      id,
      active,
    });
  }

  return {
    isUpdatingStatus,
    changeStatusModalShow,
    setChangeStatusModalShow,
    workplaceChanginStatus,
    updateWorkplaceStatus,
    handleOpenChangeStatusModal,
  };
}
